module.exports = __webpack_public_path__ + "img/facebook-logo.82b1f869.png";